import VendorCreditCreateContainer from "@legacy/vendor_credits/VendorCreditCreateContainer"

import useHasAccess from "@hooks/useHasAccess"
import useSlugExtractor from "@hooks/useSlugExtractor"
import useToastQueue from "@hooks/useToastQueue"

import { NavTopBar } from "@organisms"

import { AppFrame } from "@templates"

import { VENDOR_CREDITS_ROUTES } from "@routes/vendorCredits"

import { PERMISSION_LEVEL } from "@constants/permissionLevel"

export default function VendorCreditEdit() {
    const vendorCreditId = window.VENDOR_CREDIT_ID
    const isDraft = window.VENDOR_CREDIT_IS_DRAFT

    const [detailsRoute] = useSlugExtractor([VENDOR_CREDITS_ROUTES.DETAILS], vendorCreditId)
    const { addToastToQueue } = useToastQueue()
    const { hasPermission } = useHasAccess()

    const detailsBackDestination = hasPermission("bills_view_permission", PERMISSION_LEVEL.FULL)
        ? detailsRoute
        : undefined

    return (
        <AppFrame.Root navigationType="inner">
            <NavTopBar.Root>
                <NavTopBar.Header>
                    <NavTopBar.NavTopBarHeaderStart>
                        <NavTopBar.PageInnerTitle
                            label={isDraft ? "New Vendor Credit" : "Edit Vendor Credit"}
                            backDestination={detailsBackDestination}
                        />
                    </NavTopBar.NavTopBarHeaderStart>
                </NavTopBar.Header>
            </NavTopBar.Root>
            <AppFrame.PageContent>
                <VendorCreditCreateContainer formMode="EDIT_VENDOR_CREDIT" addToastToQueue={addToastToQueue} />
            </AppFrame.PageContent>
        </AppFrame.Root>
    )
}
